<form>
  <!-- Modal Header -->
  <div class="modal-header" style="background-color: lightyellow">
    <h4 class="modal-title">Batch Loan Payment</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <div class="col-12">
      <mat-form-field class="full-width-formField p-0">
        <input matInput readonly [matDatepicker]="endDatePicker" name="paymentDate" [(ngModel)]="paymentDate" required />
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker name="paymentDate"></mat-datepicker>
      </mat-form-field>
    </div>

    @if (paymentList.length > 0) {
      <ng-container style="display: flex; width: 100%">
        @for (payment of paymentList; track payment; let i = $index) {
          <div>
            @if (payment.isOverlap == false) {
              <mat-expansion-panel (opened)="payment.panelOpenState = true" (closed)="payment.panelOpenState = false" [expanded]="payment.panelOpenState">
                <mat-expansion-panel-header [ngClass]="getStatusColor(payment.loan.Status)">
                  <mat-panel-title style="flex: 5">
                    <button class="btn btn-info me-2" (click)="setOverlap(payment)" [hidden]="payment.loan.Scheme === 'HUTANG' || needRestrictedCustomer == true"><i class="fas fa-clone"></i></button>
                    {{ payment.loan.ReceiptNumber }} (Code: {{ payment.loan.ID }}) -
                    <span class="text-danger fw-bold">Principal : RM {{ payment.loan.Principal | number: "1.0-2" }} </span>
                    <span class="text-danger fw-bold"> | Balance : RM {{ payment.loan.Balance | number: "1.0-2" }} </span>
                    @if (payment.loan.Scheme !== "EPF") {
                      <span class="text-danger fw-bold"> | Monthly: RM {{ payment.loan.MonthlyPayment | number: "1.0-2" }}</span>
                    }
                  </mat-panel-title>
                  @if (paymentList.length > 0) {
                    <mat-panel-description>
                      <!-- Currently I am {{panelOpenState ? 'open' : 'closed'}} -->
                      <h6 class="fw-bold" [ngClass]="getPaymentColor(payment.totalPayment)">Paid : RM {{ payment.totalPayment || 0 | number: "1.0-2" }}</h6>
                    </mat-panel-description>
                  }
                </mat-expansion-panel-header>
                <!-- <p>I'm visible because I am open</p> -->
                <app-add-payment [selectedLoan]="payment.loan" (passLoanPaymentDetails)="getLoanPaymentData($event, i)" [batchDate]="paymentDate"> </app-add-payment>
              </mat-expansion-panel>
            }
          </div>
        }
      </ng-container>
    }

    @if (paymentList.length > 0) {
      <hr />
      @for (payment of paymentList; track payment; let i = $index) {
        <div>
          @if (payment.isOverlap == true) {
            <app-overlap-component class="m-2" [payment]="payment" [selectedProfile]="selectedProfile" [selectedCustomer]="selectedCustomer" [payWithSimpan]="isPayBySimpan" (passOverlapDetails)="getOverlapData($event, i)" [batchDate]="paymentDate"> </app-overlap-component>
          }
        </div>
      }
    }
  </div>

  <div class="card m-3" style="background-color: lavender">
    <div class="card-body p-1">
      <h3 class="fw-bold ms-3" style="color: rgb(192, 36, 192)">
        @if (isPayBySimpan == true) {
          <span style="color: purple">Actual: RM{{ addedSimpan + calculateExtraOverlapAmount() }} |</span>
        }
        @if (isPayBySimpan == false) {
          <span> Payment: RM {{ calculateTotalCustomerPayment() | number: "1.2-2" }}</span>
        }
        @if (isPayBySimpan == true) {
          <span> Simpan Out: RM {{ calculateTotalSimpanOut() | number: "1.2-2" }}</span>
        }
      </h3>
    </div>
  </div>
  <div class="card m-3" style="background-color: #ffe6eb">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isPayBySimpan" name="isPayBySimpan" [disabled]="sharedProfileId != undefined"> Pay By Simpan </mat-slide-toggle>
        </div>
        @if (this.isPayBySimpan == true) {
          <div class="col">
            <div class="row">
              <div class="col-6 d-flex justify-content-end align-items-end">
                <h5 class="fw-bold" style="color: indigo">
                  Simpan: RM
                  {{ selectedProfile.Reserve }}
                  @if (this.addedSimpan > 0) {
                    <span class="small fw-bold" style="color: rgb(204, 59, 204)">(+ RM{{ this.addedSimpan }})</span>
                  }
                </h5>
              </div>
              <div class="col-6 d-flex justify-content-start align-items-start">
                @if (this.selectedProfile.SharedProfileId == undefined || sharedService.checkIsMainShareProfile(selectedProfile)) {
                  <button class="btn btn-outline-dark" (click)="checkIfNeedDoReserveGroup()">Top Up</button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <hr />

  <div [hidden]="isPayBySimpan == true && this.selectedProfile.Reserve < calculateTotalSimpanOut()">
    <!--Account Number-->
    <div class="row p-3 d-flex justify-content-center align-items-center">
      <div class="col-12">
        @if (this.isPayBySimpan == false) {
          <p>To Account</p>
        }
        @if (this.isPayBySimpan == true) {
          <p>From Account</p>
        }
      </div>
      <div class="col-12">
        <select class="browser-default form-select" name="selectedAccount" [(ngModel)]="selectedAccountId">
          @for (account of companyAccountList; track account) {
            <option [value]="account.ID">{{ account.Name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disabledSubmit">Pay Loans</button>
      <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
    </div>
  </div>
  @if (isPayBySimpan == true && this.selectedProfile.Reserve < calculateTotalSimpanOut()) {
    <div class="m-3">
      <h6 class="fw-bold text-danger">You do not have enough simpan to pay, please top up first!</h6>
    </div>
  }
</form>
